// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 연차 패널 — 급여·연차 페이지(MySalaryLeave.css)에서 로드하는 Noto Sans KR 과 동일 스택.
 */
.my-leave-panel {
  font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Malgun Gothic', sans-serif;
  -webkit-font-smoothing: antialiased;
  background: var(--mrt-surface, #fcfbfa);
  border: 1px solid var(--mrt-border, #e8e6e3);
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;
  font-size: 13px;
  line-height: 1.5;
  color: #334155;
}

.my-leave-panel--empty {
  padding: 24px;
  text-align: center;
  color: var(--mrt-muted, #78716c);
  font-size: 13px;
}

.my-leave-panel__header {
  padding: 14px 18px;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  flex-shrink: 0;
}

.my-leave-panel__title {
  font-size: 1.08rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.my-leave-panel__sub {
  margin-top: 4px;
  font-size: 0.8125rem;
  color: #64748b;
  font-weight: 500;
  word-break: break-all;
}

.my-leave-panel__year-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  flex-shrink: 0;
}

.my-leave-panel__year-btn {
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 0.8125rem;
  font-weight: 600;
  font-family: inherit;
  color: #475569;
  cursor: pointer;
}

.my-leave-panel__year-btn--on {
  background: #0f172a;
  color: #fff;
  border-color: #0f172a;
}

.my-leave-panel__refresh {
  margin-left: auto;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: inherit;
  color: #475569;
  cursor: pointer;
}

.my-leave-panel__body {
  padding: 14px 16px 18px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1;
  min-height: 0;
  max-height: min(72vh, 720px);
}

.my-leave-panel__loading {
  padding: 40px;
  text-align: center;
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
}

.my-leave-balance-card {
  background: linear-gradient(145deg, #f0fdf4 0%, #ecfdf5 40%, #f8fafc 100%);
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  padding: 14px 16px 16px;
  margin-bottom: 16px;
}

.my-leave-balance-card__label {
  font-size: 12px;
  font-weight: 800;
  color: #166534;
  margin-bottom: 10px;
}

.my-leave-badges {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 10px;
}

@media (max-width: 640px) {
  .my-leave-badges {
    grid-template-columns: repeat(2, 1fr);
  }
}

.my-leave-badge {
  border-radius: 10px;
  padding: 10px 8px;
  text-align: center;
  border: 1px solid transparent;
}

.my-leave-badge--t {
  background: #fff;
  border-color: #e2e8f0;
}
.my-leave-badge--a {
  background: #fffbeb;
  border-color: #fde68a;
}
.my-leave-badge--u {
  background: #fef2f2;
  border-color: #fecaca;
}
.my-leave-badge--r {
  background: #dcfce7;
  border-color: #86efac;
}

.my-leave-badge__l {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 4px;
}

.my-leave-badge__v {
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.my-leave-base-row {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 12px;
}

.my-leave-base-row__k {
  font-weight: 700;
  margin-right: 6px;
}
.my-leave-base-row__v {
  font-weight: 800;
  color: #334155;
}
.my-leave-base-row__hint {
  display: block;
  margin-top: 4px;
  font-size: 10px;
  color: #94a3b8;
}

.my-leave-adjust-section {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px;
}

.my-leave-adjust-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 11px;
  font-weight: 800;
  color: #475569;
}

.my-leave-adjust-head--readonly {
  justify-content: flex-start;
  margin-bottom: 4px;
}

.my-leave-btn {
  border: none;
  border-radius: 7px;
  padding: 6px 12px;
  font-size: 0.8125rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.my-leave-btn--green {
  background: #16a34a;
  color: #fff;
}
.my-leave-btn--muted {
  background: #e2e8f0;
  color: #475569;
}

.my-leave-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.my-leave-muted-center {
  text-align: center;
  padding: 16px;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
}

.my-leave-muted-center--lg {
  padding: 28px 16px;
}

.my-leave-adjust-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 160px;
  overflow-y: auto;
}

.my-leave-adjust-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  font-size: 11px;
  border: 1px solid #e2e8f0;
}

.my-leave-adjust-item.pos {
  background: #f0fdf4;
}
.my-leave-adjust-item.neg {
  background: #fef2f2;
}

.my-leave-adjust-item__amt {
  font-weight: 800;
  color: #0f172a;
}
.my-leave-adjust-item__reason {
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.my-leave-adjust-item__by {
  color: #94a3b8;
  font-size: 10px;
}

.my-leave-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
  font-size: 0.9375rem;
  font-weight: 700;
  color: #334155;
}

.my-leave-section-hint {
  margin: 0 0 10px;
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  line-height: 1.4;
}

.my-leave-section-hint--tight {
  margin: 0 0 8px;
}

.my-leave-new-form {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 14px;
}

.my-leave-new-form__title {
  font-size: 12px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 12px;
}

.my-leave-new-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 12px;
}

.my-leave-new-span2 {
  grid-column: 1 / -1;
}

.my-leave-field-label {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 4px;
}

.my-leave-select,
.my-leave-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-family: inherit;
  box-sizing: border-box;
}

.my-leave-input--ro {
  background: #f1f5f9;
  color: #64748b;
}

.my-leave-half-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.my-leave-half-badge {
  background: #fef9c3;
  color: #854d0e;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
}

.my-leave-new-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.my-leave-table-wrap {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: auto;
  max-height: min(52vh, 320px);
  -webkit-overflow-scrolling: touch;
}

.my-leave-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}

.my-leave-table th {
  text-align: left;
  padding: 10px 12px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.6875rem;
  font-weight: 700;
  color: #64748b;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.my-leave-table th.c {
  text-align: center;
}

.my-leave-table__row:hover td {
  background: #fafbfc;
}

.my-leave-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  font-weight: 500;
  vertical-align: middle;
}

.my-leave-table td.c {
  text-align: center;
}

.my-leave-period-text {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
}

.my-leave-type-pill {
  border-radius: 6px;
  padding: 3px 8px;
  font-weight: 600;
  font-size: 0.75rem;
}

.my-leave-half-tag {
  margin-left: 6px;
  background: #fef9c3;
  color: #854d0e;
  border-radius: 4px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: 700;
}

.my-leave-use-minus {
  color: #dc2626;
  font-weight: 700;
}
.my-leave-use-zero {
  color: #94a3b8;
}

.my-leave-reason-cell {
  color: #64748b;
  max-width: 220px;
  vertical-align: top;
  font-weight: 400;
}

.my-leave-reason-main {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;
}

.my-leave-reject-reason {
  margin-top: 6px;
  padding: 6px 8px;
  border-radius: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
}

.my-leave-reject-reason__label {
  display: block;
  font-size: 10px;
  font-weight: 800;
  color: #b91c1c;
  text-transform: none;
  letter-spacing: 0.02em;
  margin-bottom: 2px;
}

.my-leave-del-req {
  background: #fee2e2;
  color: #dc2626;
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

.my-leave-form-err {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}

.my-leave-use-pending {
  color: #ca8a04;
  font-weight: 700;
  font-size: 11px;
}

.my-leave-status-pill {
  display: inline-block;
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 4px 9px;
  border-radius: 8px;
}

.my-leave-status--pending {
  background: #fef3c7;
  color: #92400e;
}

.my-leave-status--approved {
  background: #dcfce7;
  color: #166534;
}

.my-leave-status--rejected {
  background: #fee2e2;
  color: #b91c1c;
}

.my-leave-status--muted {
  background: #f1f5f9;
  color: #64748b;
}

/* ── 모바일: 연차 내역 카드형 + 레이아웃 ───────────────────────────── */
@media (max-width: 640px) {
  .my-leave-section-head {
    flex-direction: column;
    align-items: stretch;
  }

  .my-leave-section-head .my-leave-btn--green {
    width: 100%;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 0.875rem;
  }

  .my-leave-new-grid {
    grid-template-columns: 1fr;
  }

  .my-leave-table-wrap {
    border: none;
    background: transparent;
    max-height: none;
    overflow: visible;
    padding: 0;
  }

  .my-leave-table {
    font-size: 0.8125rem;
  }

  .my-leave-table thead {
    display: none;
  }

  .my-leave-table tbody {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  /* 카드 안: 종류·차감·상태 = 한 줄, 기간·사유 = 각각 한 줄 */
  .my-leave-table__row {
    display: grid;
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.75fr) minmax(0, 1fr);
    grid-template-areas:
      'kind deduct status'
      'period period period'
      'reason reason reason';
    column-gap: 8px;
    row-gap: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 14px 16px;
    box-shadow: 0 2px 14px rgba(15, 23, 42, 0.06);
    align-items: start;
  }

  .my-leave-td--kind {
    grid-area: kind;
  }
  .my-leave-td--deduct {
    grid-area: deduct;
  }
  .my-leave-td--status {
    grid-area: status;
  }
  .my-leave-td--period {
    grid-area: period;
  }
  .my-leave-td--reason {
    grid-area: reason;
  }

  .my-leave-table__row:hover td {
    background: transparent;
  }

  .my-leave-table__row td {
    display: block;
    min-width: 0;
    padding: 10px 0;
    border-bottom: none;
    text-align: left !important;
  }

  .my-leave-table__row td.my-leave-td--kind,
  .my-leave-table__row td.my-leave-td--deduct,
  .my-leave-table__row td.my-leave-td--status {
    padding: 0 6px 12px;
    border-bottom: none;
  }

  .my-leave-table__row td.my-leave-td--kind {
    padding-left: 0;
    text-align: left !important;
  }

  .my-leave-table__row td.my-leave-td--deduct {
    text-align: center !important;
    border-left: 1px solid #f1f5f9;
    border-right: 1px solid #f1f5f9;
    padding-left: 8px;
    padding-right: 8px;
  }

  .my-leave-table__row td.my-leave-td--status {
    padding-right: 0;
    text-align: right !important;
  }

  .my-leave-table__row td.my-leave-td--period {
    border-top: 1px solid #f1f5f9;
    border-bottom: 1px solid #f1f5f9;
    padding: 12px 0;
    margin: 0;
  }

  .my-leave-table__row td.my-leave-td--reason {
    padding: 12px 0 0;
  }

  .my-leave-table__row td::before {
    content: attr(data-label);
    display: block;
    font-size: 0.6875rem;
    font-weight: 600;
    color: #94a3b8;
    letter-spacing: 0.02em;
    margin-bottom: 6px;
  }

  .my-leave-table__row td.my-leave-td--kind::before,
  .my-leave-table__row td.my-leave-td--deduct::before,
  .my-leave-table__row td.my-leave-td--status::before {
    font-size: 0.625rem;
    margin-bottom: 4px;
  }

  .my-leave-td--kind .my-leave-type-pill {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
    font-size: 0.6875rem;
    padding: 3px 7px;
  }

  .my-leave-td--status .my-leave-status-pill {
    max-width: 100%;
    font-size: 0.625rem;
    padding: 3px 7px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .my-leave-td--deduct .my-leave-use-pending,
  .my-leave-td--deduct .my-leave-use-minus,
  .my-leave-td--deduct .my-leave-use-zero {
    font-size: 0.75rem;
  }

  .my-leave-reason-cell {
    max-width: none;
    white-space: normal;
    word-break: break-word;
    line-height: 1.45;
  }

  .my-leave-half-tag {
    display: block;
    margin-left: 0;
    margin-top: 6px;
    width: fit-content;
  }

  .my-leave-balance-card__label {
    font-size: 0.875rem;
  }
}

@media (max-width: 420px) {
  .my-leave-panel__year-row {
    gap: 6px;
  }

  .my-leave-panel__refresh {
    margin-left: 0;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 4px);
    min-width: 0;
  }
}

/* ── 휴가 신청: 달력 클릭으로 기간 선택 ───────────────────────────── */
.ml-cal {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 10px 12px;
  background: #fff;
  margin-bottom: 4px;
}

.ml-cal--compact {
  padding-bottom: 8px;
}

.ml-cal__nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.ml-cal__nav-btn {
  width: 34px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 16px;
  font-weight: 800;
  color: #475569;
  cursor: pointer;
  line-height: 1;
  font-family: inherit;
}

.ml-cal__nav-btn:hover {
  background: #e2e8f0;
}

.ml-cal__title {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.ml-cal__hint {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.45;
}

.ml-cal__hint-sub {
  display: block;
  margin-top: 4px;
  font-weight: 600;
  color: #94a3b8;
}

.ml-cal__pick-msg {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 0 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  font-size: 11px;
  font-weight: 650;
  color: #1e40af;
}

.ml-cal__pick-cancel {
  margin-left: auto;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #93c5fd;
  background: #fff;
  font-size: 11px;
  font-weight: 700;
  color: #1d4ed8;
  cursor: pointer;
  font-family: inherit;
}

.ml-cal__week {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 4px;
}

.ml-cal__weekday {
  text-align: center;
  font-size: 10px;
  font-weight: 800;
  color: #94a3b8;
  padding: 2px 0;
}

.ml-cal__grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.ml-cal__pad {
  min-height: 34px;
}

.ml-cal__day {
  min-height: 34px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  cursor: pointer;
  font-family: inherit;
  padding: 0;
  line-height: 1;
}

.ml-cal__day:hover:not(:disabled) {
  border-color: #7dd3fc;
  background: #e0f2fe;
}

.ml-cal__day--past {
  opacity: 0.35;
  cursor: not-allowed;
  background: #f1f5f9;
  color: #94a3b8;
}

.ml-cal__day--blocked {
  cursor: not-allowed;
  background: #fffbeb;
  color: #92400e;
  border: 1px dashed #f59e0b;
  font-weight: 700;
  opacity: 0.92;
}

.ml-cal__day--blocked:hover:not(:disabled) {
  background: #fffbeb;
  color: #92400e;
  border-color: #f59e0b;
}

.ml-cal__day--sun:not(.ml-cal__day--past) {
  color: #dc2626;
}

.ml-cal__day--sat:not(.ml-cal__day--past) {
  color: #2563eb;
}

.ml-cal__day--range {
  background: #dbeafe;
  color: #0c4a6e;
}

.ml-cal__day--edge {
  background: #0284c7;
  color: #fff;
  border-color: #0369a1;
  font-weight: 800;
}

.ml-cal__day--pending {
  box-shadow: 0 0 0 2px #f59e0b inset;
  background: #fffbeb;
  color: #92400e;
}

.ml-cal__day--picked {
  background: #059669;
  color: #fff;
  border-color: #047857;
  font-weight: 800;
  cursor: default;
}

.ml-cal__day--picked:hover:not(:disabled) {
  border-color: #047857;
  background: #059669;
  color: #fff;
}

.ml-cal__day--picked.ml-cal__day--sun,
.ml-cal__day--picked.ml-cal__day--sat {
  color: #fff;
}

.my-leave-picked-dates {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px 10px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;
}

.my-leave-picked-dates__label {
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
  flex: 0 0 auto;
  line-height: 28px;
}

.my-leave-picked-dates__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
}

.my-leave-date-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 10px;
  border-radius: 999px;
  border: 1px solid #a7f3d0;
  background: #ecfdf5;
  color: #065f46;
  font-size: 12px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  line-height: 1.2;
}

.my-leave-date-chip:hover {
  background: #d1fae5;
  border-color: #34d399;
}

.my-leave-date-chip__x {
  font-size: 14px;
  font-weight: 800;
  color: #047857;
  margin-left: 2px;
}

.my-leave-clear-dates {
  flex: 0 0 auto;
  align-self: center;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
}

.my-leave-clear-dates:hover {
  border-color: #cbd5e1;
  color: #334155;
}

.my-leave-cal-fallback {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 12px;
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;
}

@media (max-width: 520px) {
  .my-leave-cal-fallback {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MyLeavePanel.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,uGAAuG;EACvG,mCAAmC;EACnC,uCAAuC;EACvC,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,yEAAyE;IACzE;;;4BAGwB;IACxB,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,6CAA6C;IAC7C,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;;;IAGE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;;;IAGE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,YAAY;EACd;AACF;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/**\n * 연차 패널 — 급여·연차 페이지(MySalaryLeave.css)에서 로드하는 Noto Sans KR 과 동일 스택.\n */\n.my-leave-panel {\n  font-family: 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Malgun Gothic', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  background: var(--mrt-surface, #fcfbfa);\n  border: 1px solid var(--mrt-border, #e8e6e3);\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.8) inset;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #334155;\n}\n\n.my-leave-panel--empty {\n  padding: 24px;\n  text-align: center;\n  color: var(--mrt-muted, #78716c);\n  font-size: 13px;\n}\n\n.my-leave-panel__header {\n  padding: 14px 18px;\n  border-bottom: 1px solid #e2e8f0;\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);\n  flex-shrink: 0;\n}\n\n.my-leave-panel__title {\n  font-size: 1.08rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.my-leave-panel__sub {\n  margin-top: 4px;\n  font-size: 0.8125rem;\n  color: #64748b;\n  font-weight: 500;\n  word-break: break-all;\n}\n\n.my-leave-panel__year-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.my-leave-panel__year-btn {\n  padding: 6px 14px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #475569;\n  cursor: pointer;\n}\n\n.my-leave-panel__year-btn--on {\n  background: #0f172a;\n  color: #fff;\n  border-color: #0f172a;\n}\n\n.my-leave-panel__refresh {\n  margin-left: auto;\n  padding: 6px 12px;\n  border-radius: 8px;\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  font-size: 0.75rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #475569;\n  cursor: pointer;\n}\n\n.my-leave-panel__body {\n  padding: 14px 16px 18px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  min-height: 0;\n  max-height: min(72vh, 720px);\n}\n\n.my-leave-panel__loading {\n  padding: 40px;\n  text-align: center;\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.my-leave-balance-card {\n  background: linear-gradient(145deg, #f0fdf4 0%, #ecfdf5 40%, #f8fafc 100%);\n  border: 1px solid #bbf7d0;\n  border-radius: 12px;\n  padding: 14px 16px 16px;\n  margin-bottom: 16px;\n}\n\n.my-leave-balance-card__label {\n  font-size: 12px;\n  font-weight: 800;\n  color: #166534;\n  margin-bottom: 10px;\n}\n\n.my-leave-badges {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 640px) {\n  .my-leave-badges {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.my-leave-badge {\n  border-radius: 10px;\n  padding: 10px 8px;\n  text-align: center;\n  border: 1px solid transparent;\n}\n\n.my-leave-badge--t {\n  background: #fff;\n  border-color: #e2e8f0;\n}\n.my-leave-badge--a {\n  background: #fffbeb;\n  border-color: #fde68a;\n}\n.my-leave-badge--u {\n  background: #fef2f2;\n  border-color: #fecaca;\n}\n.my-leave-badge--r {\n  background: #dcfce7;\n  border-color: #86efac;\n}\n\n.my-leave-badge__l {\n  font-size: 0.6875rem;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.my-leave-badge__v {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n}\n\n.my-leave-base-row {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 12px;\n}\n\n.my-leave-base-row__k {\n  font-weight: 700;\n  margin-right: 6px;\n}\n.my-leave-base-row__v {\n  font-weight: 800;\n  color: #334155;\n}\n.my-leave-base-row__hint {\n  display: block;\n  margin-top: 4px;\n  font-size: 10px;\n  color: #94a3b8;\n}\n\n.my-leave-adjust-section {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 12px;\n}\n\n.my-leave-adjust-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  font-size: 11px;\n  font-weight: 800;\n  color: #475569;\n}\n\n.my-leave-adjust-head--readonly {\n  justify-content: flex-start;\n  margin-bottom: 4px;\n}\n\n.my-leave-btn {\n  border: none;\n  border-radius: 7px;\n  padding: 6px 12px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.my-leave-btn--green {\n  background: #16a34a;\n  color: #fff;\n}\n.my-leave-btn--muted {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n.my-leave-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.my-leave-muted-center {\n  text-align: center;\n  padding: 16px;\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n\n.my-leave-muted-center--lg {\n  padding: 28px 16px;\n}\n\n.my-leave-adjust-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 160px;\n  overflow-y: auto;\n}\n\n.my-leave-adjust-item {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  font-size: 11px;\n  border: 1px solid #e2e8f0;\n}\n\n.my-leave-adjust-item.pos {\n  background: #f0fdf4;\n}\n.my-leave-adjust-item.neg {\n  background: #fef2f2;\n}\n\n.my-leave-adjust-item__amt {\n  font-weight: 800;\n  color: #0f172a;\n}\n.my-leave-adjust-item__reason {\n  color: #64748b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.my-leave-adjust-item__by {\n  color: #94a3b8;\n  font-size: 10px;\n}\n\n.my-leave-section-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 4px;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  color: #334155;\n}\n\n.my-leave-section-hint {\n  margin: 0 0 10px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #94a3b8;\n  line-height: 1.4;\n}\n\n.my-leave-section-hint--tight {\n  margin: 0 0 8px;\n}\n\n.my-leave-new-form {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 14px;\n  margin-bottom: 14px;\n}\n\n.my-leave-new-form__title {\n  font-size: 12px;\n  font-weight: 800;\n  color: #0f172a;\n  margin-bottom: 12px;\n}\n\n.my-leave-new-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 12px;\n}\n\n.my-leave-new-span2 {\n  grid-column: 1 / -1;\n}\n\n.my-leave-field-label {\n  font-size: 10px;\n  font-weight: 700;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.my-leave-select,\n.my-leave-input {\n  width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  font-size: 0.8125rem;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n\n.my-leave-input--ro {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.my-leave-half-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.my-leave-half-badge {\n  background: #fef9c3;\n  color: #854d0e;\n  border-radius: 6px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.my-leave-new-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.my-leave-table-wrap {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: auto;\n  max-height: min(52vh, 320px);\n  -webkit-overflow-scrolling: touch;\n}\n\n.my-leave-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n}\n\n.my-leave-table th {\n  text-align: left;\n  padding: 10px 12px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  color: #64748b;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.my-leave-table th.c {\n  text-align: center;\n}\n\n.my-leave-table__row:hover td {\n  background: #fafbfc;\n}\n\n.my-leave-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n  font-weight: 500;\n  vertical-align: middle;\n}\n\n.my-leave-table td.c {\n  text-align: center;\n}\n\n.my-leave-period-text {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n}\n\n.my-leave-type-pill {\n  border-radius: 6px;\n  padding: 3px 8px;\n  font-weight: 600;\n  font-size: 0.75rem;\n}\n\n.my-leave-half-tag {\n  margin-left: 6px;\n  background: #fef9c3;\n  color: #854d0e;\n  border-radius: 4px;\n  padding: 1px 6px;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.my-leave-use-minus {\n  color: #dc2626;\n  font-weight: 700;\n}\n.my-leave-use-zero {\n  color: #94a3b8;\n}\n\n.my-leave-reason-cell {\n  color: #64748b;\n  max-width: 220px;\n  vertical-align: top;\n  font-weight: 400;\n}\n\n.my-leave-reason-main {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 220px;\n}\n\n.my-leave-reject-reason {\n  margin-top: 6px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.my-leave-reject-reason__label {\n  display: block;\n  font-size: 10px;\n  font-weight: 800;\n  color: #b91c1c;\n  text-transform: none;\n  letter-spacing: 0.02em;\n  margin-bottom: 2px;\n}\n\n.my-leave-del-req {\n  background: #fee2e2;\n  color: #dc2626;\n  border: none;\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.my-leave-form-err {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n.my-leave-use-pending {\n  color: #ca8a04;\n  font-weight: 700;\n  font-size: 11px;\n}\n\n.my-leave-status-pill {\n  display: inline-block;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  padding: 4px 9px;\n  border-radius: 8px;\n}\n\n.my-leave-status--pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.my-leave-status--approved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.my-leave-status--rejected {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.my-leave-status--muted {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n/* ── 모바일: 연차 내역 카드형 + 레이아웃 ───────────────────────────── */\n@media (max-width: 640px) {\n  .my-leave-section-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .my-leave-section-head .my-leave-btn--green {\n    width: 100%;\n    padding: 10px 14px;\n    border-radius: 10px;\n    font-size: 0.875rem;\n  }\n\n  .my-leave-new-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .my-leave-table-wrap {\n    border: none;\n    background: transparent;\n    max-height: none;\n    overflow: visible;\n    padding: 0;\n  }\n\n  .my-leave-table {\n    font-size: 0.8125rem;\n  }\n\n  .my-leave-table thead {\n    display: none;\n  }\n\n  .my-leave-table tbody {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  /* 카드 안: 종류·차감·상태 = 한 줄, 기간·사유 = 각각 한 줄 */\n  .my-leave-table__row {\n    display: grid;\n    grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.75fr) minmax(0, 1fr);\n    grid-template-areas:\n      'kind deduct status'\n      'period period period'\n      'reason reason reason';\n    column-gap: 8px;\n    row-gap: 0;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 14px;\n    padding: 14px 16px;\n    box-shadow: 0 2px 14px rgba(15, 23, 42, 0.06);\n    align-items: start;\n  }\n\n  .my-leave-td--kind {\n    grid-area: kind;\n  }\n  .my-leave-td--deduct {\n    grid-area: deduct;\n  }\n  .my-leave-td--status {\n    grid-area: status;\n  }\n  .my-leave-td--period {\n    grid-area: period;\n  }\n  .my-leave-td--reason {\n    grid-area: reason;\n  }\n\n  .my-leave-table__row:hover td {\n    background: transparent;\n  }\n\n  .my-leave-table__row td {\n    display: block;\n    min-width: 0;\n    padding: 10px 0;\n    border-bottom: none;\n    text-align: left !important;\n  }\n\n  .my-leave-table__row td.my-leave-td--kind,\n  .my-leave-table__row td.my-leave-td--deduct,\n  .my-leave-table__row td.my-leave-td--status {\n    padding: 0 6px 12px;\n    border-bottom: none;\n  }\n\n  .my-leave-table__row td.my-leave-td--kind {\n    padding-left: 0;\n    text-align: left !important;\n  }\n\n  .my-leave-table__row td.my-leave-td--deduct {\n    text-align: center !important;\n    border-left: 1px solid #f1f5f9;\n    border-right: 1px solid #f1f5f9;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .my-leave-table__row td.my-leave-td--status {\n    padding-right: 0;\n    text-align: right !important;\n  }\n\n  .my-leave-table__row td.my-leave-td--period {\n    border-top: 1px solid #f1f5f9;\n    border-bottom: 1px solid #f1f5f9;\n    padding: 12px 0;\n    margin: 0;\n  }\n\n  .my-leave-table__row td.my-leave-td--reason {\n    padding: 12px 0 0;\n  }\n\n  .my-leave-table__row td::before {\n    content: attr(data-label);\n    display: block;\n    font-size: 0.6875rem;\n    font-weight: 600;\n    color: #94a3b8;\n    letter-spacing: 0.02em;\n    margin-bottom: 6px;\n  }\n\n  .my-leave-table__row td.my-leave-td--kind::before,\n  .my-leave-table__row td.my-leave-td--deduct::before,\n  .my-leave-table__row td.my-leave-td--status::before {\n    font-size: 0.625rem;\n    margin-bottom: 4px;\n  }\n\n  .my-leave-td--kind .my-leave-type-pill {\n    display: inline-block;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    vertical-align: middle;\n    font-size: 0.6875rem;\n    padding: 3px 7px;\n  }\n\n  .my-leave-td--status .my-leave-status-pill {\n    max-width: 100%;\n    font-size: 0.625rem;\n    padding: 3px 7px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .my-leave-td--deduct .my-leave-use-pending,\n  .my-leave-td--deduct .my-leave-use-minus,\n  .my-leave-td--deduct .my-leave-use-zero {\n    font-size: 0.75rem;\n  }\n\n  .my-leave-reason-cell {\n    max-width: none;\n    white-space: normal;\n    word-break: break-word;\n    line-height: 1.45;\n  }\n\n  .my-leave-half-tag {\n    display: block;\n    margin-left: 0;\n    margin-top: 6px;\n    width: fit-content;\n  }\n\n  .my-leave-balance-card__label {\n    font-size: 0.875rem;\n  }\n}\n\n@media (max-width: 420px) {\n  .my-leave-panel__year-row {\n    gap: 6px;\n  }\n\n  .my-leave-panel__refresh {\n    margin-left: 0;\n    flex: 1 1 calc(50% - 4px);\n    min-width: 0;\n  }\n}\n\n/* ── 휴가 신청: 달력 클릭으로 기간 선택 ───────────────────────────── */\n.ml-cal {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 10px 10px 12px;\n  background: #fff;\n  margin-bottom: 4px;\n}\n\n.ml-cal--compact {\n  padding-bottom: 8px;\n}\n\n.ml-cal__nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.ml-cal__nav-btn {\n  width: 34px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  font-size: 16px;\n  font-weight: 800;\n  color: #475569;\n  cursor: pointer;\n  line-height: 1;\n  font-family: inherit;\n}\n\n.ml-cal__nav-btn:hover {\n  background: #e2e8f0;\n}\n\n.ml-cal__title {\n  font-size: 13px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.ml-cal__hint {\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.ml-cal__hint-sub {\n  display: block;\n  margin-top: 4px;\n  font-weight: 600;\n  color: #94a3b8;\n}\n\n.ml-cal__pick-msg {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  font-size: 11px;\n  font-weight: 650;\n  color: #1e40af;\n}\n\n.ml-cal__pick-cancel {\n  margin-left: auto;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid #93c5fd;\n  background: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  color: #1d4ed8;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.ml-cal__week {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n  margin-bottom: 4px;\n}\n\n.ml-cal__weekday {\n  text-align: center;\n  font-size: 10px;\n  font-weight: 800;\n  color: #94a3b8;\n  padding: 2px 0;\n}\n\n.ml-cal__grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n}\n\n.ml-cal__pad {\n  min-height: 34px;\n}\n\n.ml-cal__day {\n  min-height: 34px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: #f8fafc;\n  font-size: 12px;\n  font-weight: 700;\n  color: #334155;\n  cursor: pointer;\n  font-family: inherit;\n  padding: 0;\n  line-height: 1;\n}\n\n.ml-cal__day:hover:not(:disabled) {\n  border-color: #7dd3fc;\n  background: #e0f2fe;\n}\n\n.ml-cal__day--past {\n  opacity: 0.35;\n  cursor: not-allowed;\n  background: #f1f5f9;\n  color: #94a3b8;\n}\n\n.ml-cal__day--blocked {\n  cursor: not-allowed;\n  background: #fffbeb;\n  color: #92400e;\n  border: 1px dashed #f59e0b;\n  font-weight: 700;\n  opacity: 0.92;\n}\n\n.ml-cal__day--blocked:hover:not(:disabled) {\n  background: #fffbeb;\n  color: #92400e;\n  border-color: #f59e0b;\n}\n\n.ml-cal__day--sun:not(.ml-cal__day--past) {\n  color: #dc2626;\n}\n\n.ml-cal__day--sat:not(.ml-cal__day--past) {\n  color: #2563eb;\n}\n\n.ml-cal__day--range {\n  background: #dbeafe;\n  color: #0c4a6e;\n}\n\n.ml-cal__day--edge {\n  background: #0284c7;\n  color: #fff;\n  border-color: #0369a1;\n  font-weight: 800;\n}\n\n.ml-cal__day--pending {\n  box-shadow: 0 0 0 2px #f59e0b inset;\n  background: #fffbeb;\n  color: #92400e;\n}\n\n.ml-cal__day--picked {\n  background: #059669;\n  color: #fff;\n  border-color: #047857;\n  font-weight: 800;\n  cursor: default;\n}\n\n.ml-cal__day--picked:hover:not(:disabled) {\n  border-color: #047857;\n  background: #059669;\n  color: #fff;\n}\n\n.ml-cal__day--picked.ml-cal__day--sun,\n.ml-cal__day--picked.ml-cal__day--sat {\n  color: #fff;\n}\n\n.my-leave-picked-dates {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 8px 10px;\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px dashed #e2e8f0;\n}\n\n.my-leave-picked-dates__label {\n  font-size: 11px;\n  font-weight: 800;\n  color: #64748b;\n  flex: 0 0 auto;\n  line-height: 28px;\n}\n\n.my-leave-picked-dates__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.my-leave-date-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px 4px 10px;\n  border-radius: 999px;\n  border: 1px solid #a7f3d0;\n  background: #ecfdf5;\n  color: #065f46;\n  font-size: 12px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  line-height: 1.2;\n}\n\n.my-leave-date-chip:hover {\n  background: #d1fae5;\n  border-color: #34d399;\n}\n\n.my-leave-date-chip__x {\n  font-size: 14px;\n  font-weight: 800;\n  color: #047857;\n  margin-left: 2px;\n}\n\n.my-leave-clear-dates {\n  flex: 0 0 auto;\n  align-self: center;\n  padding: 4px 10px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.my-leave-clear-dates:hover {\n  border-color: #cbd5e1;\n  color: #334155;\n}\n\n.my-leave-cal-fallback {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 12px;\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px dashed #e2e8f0;\n}\n\n@media (max-width: 520px) {\n  .my-leave-cal-fallback {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
